import request from '../utils/request'

export function toUserInfo(data) {
    return request({
        url: '/api/chatitem/to_user_info?to_user_id='+data.to_user_id+'&chat_type='+data.chat_type,
        method: 'get'
    })
}

export function listByUser(data) {
    return request({
        url: '/api/chat/listByUser?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&to_user_id='+data.to_user_id+'&chat_type='+data.chat_type,
        method: 'get'
    })
}

export function listSelf(data) {
    return request({
        url: '/api/chatitem/list_self',
        method: 'get',
        params: data
    })
}

export function list_self_new(data){
    return request({
        url: '/api/chatitem/list_self_new?pageNum='+data.pageNum+'&pageSize='+data.pageSize+'&to_user_id='+data.to_user_id+'&chat_type='+data.chat_type+'&max_id='+data.max_id+'&max_time='+data.max_time,
        method: 'get'
    })
}

export function selfAdd(data){
    return request({
        url: '/api/chatitem/add',
        method: 'post',
        data
    })
}

export function infoByUser(data){
    return request({
        url: '/api/chat/infoByUser',
        method: 'get',
        params: data
    })
}

export function remarkInfoByUser(data){
    return request({
        url: '/api/remark/infoByUser',
        method: 'get',
        params: data
    })
}
export function remarkAdd(data){
    return request({
        url: '/api/remark/add',
        method: 'post',
        data
    })
}

export function remarkUpdata(data){
    return request({
        url: '/api/remark/updateSelf',
        method: 'post',
        data
    })
}

export function listCustUser(data){
    return request({
        url: '/api/open/uni/listCustUser',
        method: 'get'
    })
}